import React from "react";
import ProjectIcon from "../../../Assets/Images/Sustenance/ProjectIcon.svg";
import { statusPalette } from "../cpSourcingTheme";
import { fmtVisitDateTime } from "../cpSourcingFormat";
import css from "./cpSourcingMobile.module.css";

const StatusPill = ({ status }) => {
  const p = statusPalette(status);
  return (
    <span
      className={css.statusPill}
      style={{ background: p.bg, color: p.color, border: `1px solid ${p.border}` }}
    >
      <span className={css.statusDot} style={{ background: p.dot }} />
      {p.label}
    </span>
  );
};

// One CP site visit as a card — the mobile stand-in for a DataGrid row.
//
// `canView` comes straight from the view's canViewRow predicate. When it is
// false the body renders as a plain div: no button, nothing to tap, and no
// misleading disabled control. Verify/Reject stays gated by canApproveRow
// inside ViewCpSiteVisitDetails, exactly as on desktop.
export default function SiteVisitCard({ row, canView, onOpen }) {
  const avatar = row.photoUrl
    ? process.env.REACT_APP_SUPABASE_BUCKET_PREFIX + row.photoUrl
    : ProjectIcon;

  const body = (
    <>
      <div className={css.cardIdentity}>
        <img
          className={css.cardAvatar}
          src={avatar}
          alt=""
          // Same fallback the grid cell uses, so a broken URL looks identical
          // on both layouts.
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = ProjectIcon;
          }}
        />
        <span className={css.cardTitle}>{row.cpName || "-"}</span>
      </div>

      <div className={css.kv}>
        <span className={css.kvKey}>CP Sourcing</span>
        <span className={css.kvValue}>{row.cpSourceName || "-"}</span>
      </div>
      <div className={css.kv} style={{ marginBottom: 0 }}>
        <span className={css.kvKey}>Visit</span>
        <span className={css.kvValue}>{fmtVisitDateTime(row.dateTime)}</span>
      </div>
    </>
  );

  return (
    <div className={css.card}>
      <div className={css.cardHeader}>
        <span className={css.cardId}>
          {row.cpDisplayId ? `#${row.cpDisplayId}` : "-"}
        </span>
        <StatusPill status={row.status} />
      </div>

      {canView ? (
        <button
          type="button"
          className={`${css.cardBody} ${css.cardBodyTappable}`}
          onClick={() => onOpen(row)}
        >
          {body}
        </button>
      ) : (
        <div className={css.cardBody}>{body}</div>
      )}
    </div>
  );
}
